import { render } from "./firm.vue?vue&type=template&id=14a5b2d8&scoped=true"
import script from "./firm.vue?vue&type=script&lang=js"
export * from "./firm.vue?vue&type=script&lang=js"

import "./firm.vue?vue&type=style&index=0&id=14a5b2d8&lang=less&scoped=true"

import exportComponent from "D:\\workstudio\\website67\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a5b2d8"]])

export default __exports__